<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* Global font application handled in main.css */
</style>
